require('./personeticsPieChart.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @helpers
const { formatText } = require('core/i18n').i18n;

// @category icons
const categoryHome = require("assets/icons/categories/category-icon-casa-y-hogar.svg");
const categoryTransport = require("assets/icons/categories/category-icon-transporte.svg");
const categoryEducation = require("assets/icons/categories/category-icon-educacion.svg");
const categoryRetail = require("assets/icons/categories/category-icon-comercio-y-tiendas.svg");
const categoryTravel = require("assets/icons/categories/category-icon-ocio.svg");
const categoryRestaurant = require("assets/icons/categories/category-icon-restaurantes.svg");
const categoryInsurance = require("assets/icons/categories/category-icon-seguros.svg");
const categoryOtherExpenditure = require("assets/icons/categories/category-icon-otros-gastos.svg");
const categoryATMs = require("assets/icons/categories/category-icon-cajeros.svg");
const categoryLoans = require("assets/icons/categories/category-icon-transferencias.svg");
const categoryIncome = require("assets/icons/categories/category-icon-ingresos.svg");
const categoryInvestments = require("assets/icons/categories/category-icon-inversiones.svg");
const categoryTransactions = require("assets/icons/categories/category-icon-movimientos-excluidos.svg");

class PersoneticsPieChart extends React.Component {

    render() {

        const { insight } = this.props;
        let labels = ['label1', 'label2', 'label3'];
        const categoryObject = insight.get('teaserBlocks').filter((teaser) => {
            return labels.includes(teaser.get('blockId'))
        });
        const valueObject = insight.get('teaserBlocks').filter((teaser) => {
            return teaser.get('type') === "pie-chart"
        });
        const categories = categoryObject.map(i => {
            return i.get('text');
        });
        const pieChartObject = valueObject.map((x, i) => {
            return { "category": categories.get(`${i}`), "percentage": x.get('centerText') }
        });

        const pieChartContent = pieChartObject.map((pieChart, key) => {
            const category = pieChart.category;
            let categoryTypeSrc;
            switch (category.toLowerCase()) {
                case formatText('personetics-personetics_pieChartCategoryHome'):
                    categoryTypeSrc = categoryHome;
                    break;
                case formatText('personetics-personetics_pieChartCategoryTransport'):
                    categoryTypeSrc = categoryTransport;
                    break;
                case formatText('personetics-personetics_pieChartCategoryEducation'):
                    categoryTypeSrc = categoryEducation;
                    break;
                case formatText('personetics-personetics_pieChartCategoryRetail'):
                    categoryTypeSrc = categoryRetail;
                    break;
                case formatText('personetics-personetics_pieChartCategoryTravel'):
                    categoryTypeSrc = categoryTravel;
                    break;
                case formatText('personetics-personetics_pieChartCategoryRestaurant'):
                    categoryTypeSrc = categoryRestaurant;
                    break;
                case formatText('personetics-personetics_pieChartCategoryInsurance'):
                    categoryTypeSrc = categoryInsurance;
                    break;
                case formatText('personetics-personetics_pieChartCategoryOtherExpenditure'):
                    categoryTypeSrc = categoryOtherExpenditure;
                    break;
                case formatText('personetics-personetics_pieChartCategoryATMs'):
                    categoryTypeSrc = categoryATMs;
                    break;
                case formatText('personetics-personetics_pieChartCategoryLoans'):
                    categoryTypeSrc = categoryLoans;
                    break;
                case formatText('personetics-personetics_pieChartCategoryIncome'):
                    categoryTypeSrc = categoryIncome;
                    break;
                case formatText('personetics-personetics_pieChartCategoryInvestments'):
                    categoryTypeSrc = categoryInvestments;
                    break;
                case formatText('personetics-personetics_pieChartCategoryTransactions'):
                    categoryTypeSrc = categoryTransactions;
                    break;
                default:
                    categoryTypeSrc = categoryOtherExpenditure;
                    break;
            }

            return (
                <div key={key} className="personetics-pie-chart__content col-xs-4">
                    <img className="personetics-pie-chart__icon" src={categoryTypeSrc}/>
                    <div className="personetics-pie-chart__value">
                        {pieChart.percentage}
                    </div>
                </div>
            )
        })

        return (
            <div className="col-xs-12">
                <div className="row">
                    {pieChartContent}
                </div>
            </div>
        );
    }
}

PersoneticsPieChart.propTypes = {
    insight: PropTypes.object.isRequired
};

module.exports = PersoneticsPieChart;


